if (!customElements.get('aryveda-faq')) {
  class AryvedaFaq extends HTMLElement {
    constructor() {
      super();

      this.items = Array.from(this.querySelectorAll('.ald-faq__item'));
      this.items.forEach((item) => {
        const trigger = item.querySelector('.ald-faq__trigger');
        if (trigger) trigger.addEventListener('click', () => this.toggle(item));
      });
    }

    toggle(item) {
      const trigger = item.querySelector('.ald-faq__trigger');
      const panel = item.querySelector('.ald-faq__answer');
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      trigger.setAttribute('aria-expanded', String(!isOpen));
      item.classList.toggle('is-open', !isOpen);

      if (panel) {
        panel.style.maxHeight = isOpen ? null : `${panel.scrollHeight}px`;
      }
    }
  }

  customElements.define('aryveda-faq', AryvedaFaq);
}
